module.exports = __webpack_public_path__ + "static/img/LOGO.7f5bfd5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameDetails/FenyxRising/LOGO.png
// module id = AV96
// module chunks = 0